import axios from "axios";
import React, {useState} from "react";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css"

export default function Dictionary(props) {
  let [keyword, setKeyword] = useState(props.defaultKeyword);
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);

  function handleDictionaryResponse(res) {
    setResults(res.data[0]);
  }
  function handlePexelResponse(res) {
   setPhotos(res.data.photos);
  }

  function search() {
    let apiUrl=`https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleDictionaryResponse);

    const pexelApiKey = "563492ad6f91700001000001a02fbd78ab89432b9e0335e5690ea523";
    let pexelApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
    let headers= { Authorization: `Bearer ${pexelApiKey}`}
    axios.get(pexelApiUrl, {headers: headers}).then(handlePexelResponse);
  }

  function handleSubmit(e) {
    e.preventDefault();
    search();
  }

  

  function handleKeywordChange(e) {
setKeyword(e.target.value);
  }

  function load() {
setLoaded(true);
search();
  }

  if (loaded) {
    return (
      <div className="Dictionary">
        <section>
        <form onSubmit={handleSubmit}>
          <input type="search" placeholder="Type a word..." onChange={handleKeywordChange} autoFocus={true}></input>
        </form>
        </section>
        <Results results={results} />
        <Photos photos={photos} />
      </div>
    );
  }else {
    load();
    return"loading";
  }
  
}



